// extracted by mini-css-extract-plugin
export default {"errorScreen":"ErrorMessage_errorScreen__9tu7m","closed":"ErrorMessage_closed__Kzeuf","isAppViewError":"ErrorMessage_isAppViewError__Kw-tT"};